import MenuButton, { MenuItem } from 'components/molecules/Menu/index';
import React, { useState } from 'react';
import { AuthContext } from 'context/authContext';
// import ChangeStatusForm from 'components/organisms/ChangeStatusForm';
import ConfigurationForm from 'components/organisms/ConfigurationForm';
import ConfirmationModal from 'components/molecules/ConfirmationModal';
import DeviceDetails from 'components/organisms/DeviceDetails';
import DeviceForm from 'components/organisms/DeviceForm';
import ModalContainer from 'components/molecules/ModalContainer';

import Toast from 'components/molecules/Toast';
import deviceService from 'services/deviceService';
import Loaders from 'components/atoms/Loaders';
import { useContextHook } from 'use-context-hook';
import configurationService from 'services/configurationService';
import CaptchaComponent from '../CaptchaComponent';
import FunctionalLoaders from '../FunctionalLoaders';
import TagStringUpdate from '../TagStringForm';
import DeviceLocationMap from '../DeviceLocationMap';
import DownloadDeviceLogs from '../DownloadDeviceLogs';
import DeviceOpenSearchLogs from '../DeviceOpenSearchLogs';

function DevicesActions({ _, setIgnoreMqtt }) {
  const [loading, setLoading] = useState(false);
  const [modelsState, setModelsState] = useState({});
  const [isFetching, setIsFetching] = useState(false);
  const [configuration, setConfiguration] = useState({});
  const [isError, setIsError] = useState(false);

  const { refetch, hasPermission } = useContextHook(AuthContext, ['refetch', 'hasPermission']);
  const canViewOpenSearchLogs = hasPermission('device.view-opensearch-logs') || hasPermission('device.download-logs');

  const handleConfigFetch = async id => {
    setIsFetching(true);
    try {
      const response = await configurationService.getConfiguration(id);
      setConfiguration(response?.data?.configuration);
      setIsFetching(false);
    } catch (error) {
      setIsError(true);
      Toast({
        type: 'error',
        message: 'Somthing went wrong!',
      });
    }
  };

  const onDeleteDevice = async id => {
    try {
      setLoading(true);
      const { success, message } = await deviceService.deleteDevice(id);

      if (success) {
        Toast({
          type: 'success',
          message,
        });
        refetch();
      }
    } catch (error) {
      Toast({
        type: 'error',
        message: error.message ?? 'Something Went Wrong',
      });
    }
    setLoading(false);
  };

  const onRevokeAPI = async id => {
    try {
      setLoading(true);

      const { success, message } = await deviceService.revokeApiKey(id);

      if (success) {
        Toast({
          type: 'success',
          message,
        });
        refetch();
      }
    } catch (error) {
      Toast({
        type: 'error',
        message: error.message ?? 'Something Went Wrong',
      });
    }
    setLoading(false);
  };

  const onToggleDeactivate = async id => {
    try {
      setLoading(true);

      const { success, message } = await deviceService.onToggleDeactivate(id);

      if (success) {
        Toast({
          type: 'success',
          message,
        });
        refetch();
      }
    } catch (error) {
      Toast({
        type: 'error',
        message: error.message ?? 'Something Went Wrong',
      });
    }
    setLoading(false);
  };

  const checkRoom = open => {
    if (!open) {
      if (!Object.values(modelsState).includes(true)) {
        setIgnoreMqtt(false);
      }
    }
  };

  return (
    <MenuButton
      icon={
        // eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions
        <span
          className="material-icons-outlined"
          onClick={() => {
            setIgnoreMqtt(true);
          }}>
          more_vert
        </span>
      }
      onMenuChange={({ open }) => {
        checkRoom(open);
      }}>
      <ModalContainer
        lg
        stateChanged={__ => setModelsState(___ => ({ ...___, ...__ }))}
        onModalClose={() => {
          setIgnoreMqtt(false);
        }}
        title="Device Details"
        content={({ onClose }) => <DeviceDetails device={_} onClose={onClose} />}
        btnComponent={({ onClick }) => (
          <MenuItem
            icon={<i className="material-icons-outlined">description</i>}
            className="detail-btn"
            onClick={() => {
              setIgnoreMqtt(true);
              onClick();
            }}>
            Device Details
          </MenuItem>
        )}
      />

      {hasPermission('device.edit') && (
        <ModalContainer
          lg
          title="Update Device"
          stateChanged={__ => setModelsState(___ => ({ ...___, ...__ }))}
          onModalClose={() => {
            setIgnoreMqtt(false);
          }}
          btnComponent={({ onClick }) => (
            <MenuItem
              icon={<span className="material-icons-outlined">edit</span>}
              onClick={() => {
                setIgnoreMqtt(true);
                onClick();
              }}>
              Update Device
            </MenuItem>
          )}
          content={({ onClose }) => <DeviceForm onClose={onClose} device={_} edit storeId={_.store_id} />}
        />
      )}

      {hasPermission('device.see-configurations') && ( // _.status === 'Active' && (
        <ModalContainer
          stateChanged={__ => setModelsState(___ => ({ ...___, ...__ }))}
          width={1800}
          title="Device Setting"
          isClosable={false}
          onModalClose={() => {
            setIgnoreMqtt(false);
          }}
          btnComponent={({ onClick }) => (
            <MenuItem
              icon={<span className="material-icons-outlined">edit</span>}
              onClick={() => {
                handleConfigFetch(_.configId);
                setIgnoreMqtt(true);
                onClick();
              }}>
              Update Config
            </MenuItem>
          )}
          content={({ onClose }) =>
            isFetching ? (
              <FunctionalLoaders onClose={onClose} isFetching={isFetching} isError={isError} />
            ) : (
              <ConfigurationForm
                edit
                device={_}
                onClose={onClose}
                isFetching={isFetching}
                configuration={configuration}
              />
            )
          }
        />
      )}

      {hasPermission('device.revoke') &&
        (_.status === 'Active' || _.status === 'PendingActivation' || _.status === 'ForcedDeactivated') && (
          <ConfirmationModal
            stateChanged={__ => setModelsState(___ => ({ ...___, ...__ }))}
            onModalClose={() => {
              setIgnoreMqtt(false);
            }}
            title="Are you sure you want to revoke api key?"
            subtitle="you can't undo this action"
            confirmationModal="Sure"
            okLoading={loading}
            onOk={() => onRevokeAPI(_._id)}
            btnComponent={({ onClick }) => (
              <MenuItem
                icon={<span className="material-icons-outlined">undo</span>}
                onClick={() => {
                  setIgnoreMqtt(true);
                  onClick();
                }}>
                Reset OTP
              </MenuItem>
            )}
          />
        )}
      {/*
      {hasPermission('device.change-device-status') &&
        _.status !== 'PendingActivation' &&
        _.status !== 'ForcedDeactivated' && (
          <ModalContainer
            stateChanged={__ => setModelsState(___ => ({ ...___, ...__ }))}
            onModalClose={() => {
              setIgnoreMqtt(false);
            }}
            lg
            title="Change Device Status"
            btnComponent={({ onClick }) => (
              <MenuItem
                onClick={() => {
                  setIgnoreMqtt(true);
                  onClick();
                }}
                icon={<i className="material-icons-outlined">update</i>}>
                Change Status
              </MenuItem>
            )}
            content={({ onClose }) => (
              <ChangeStatusForm onClose={onClose} id={_._id} device status={_.status} device_api_key={_?.api_key} />
            )}
          />
        )} */}

      {hasPermission('device.force-deactivate') && _.status !== 'ForcedDeactivated' && (
        <ConfirmationModal
          stateChanged={__ => setModelsState(___ => ({ ...___, ...__ }))}
          onModalClose={() => {
            setIgnoreMqtt(false);
          }}
          title={`Are you sure you want to ${_.status === 'Active' ? 'Deactivate' : 'Reactivate'} this device?`}
          confirmationModal="Sure"
          okLoading={loading}
          onOk={() => onToggleDeactivate(_._id)}
          btnComponent={({ onClick }) => (
            <MenuItem
              className={_.status === 'Active' ? 'deactivate-btn' : 'reactivate-btn'}
              icon={
                <span className="material-icons-outlined">
                  {_.status === 'Active' ? 'power_settings_new' : 'restart_alt'}
                </span>
              }
              onClick={() => {
                setIgnoreMqtt(true);
                onClick();
              }}>
              {_.status === 'Active' ? 'Deactivate Device' : 'Reactivate Device'}
            </MenuItem>
          )}
        />
      )}
      {_.status === 'Active' && (
        <ConfirmationModal
          stateChanged={__ => setModelsState(___ => ({ ...___, ...__ }))}
          onModalClose={() => {
            setIgnoreMqtt(false);
          }}
          title="Are you sure you want to resync configuration?"
          confirmationModal="Sure"
          okLoading={loading}
          onOk={() => {
            setLoading(true);
            configurationService
              .resyncConfiguration(_.serial_number)
              .then(({ success, message }) => {
                if (success) {
                  Toast({
                    type: 'success',
                    message,
                  });
                }
                setLoading(false);
              })
              .catch(error => {
                Toast({
                  type: 'error',
                  message: error.message ?? 'Something Went Wrong',
                });
                setLoading(false);
              });
          }}
          btnComponent={({ onClick }) => (
            <MenuItem
              icon={<span className="material-icons-outlined">sync</span>}
              onClick={() => {
                setIgnoreMqtt(true);
                onClick();
              }}>
              Resync Configuration
            </MenuItem>
          )}
        />
      )}
      {hasPermission('device.delete') && (
        <ModalContainer
          stateChanged={__ => setModelsState(___ => ({ ...___, ...__ }))}
          lg
          onModalClose={() => {
            setIgnoreMqtt(false);
          }}
          title="Are you sure you want to Delete Device?"
          btnComponent={({ onClick }) => (
            <MenuItem
              className="delete-btn"
              icon={<span className="material-icons-outlined">delete_forever</span>}
              onClick={() => {
                setIgnoreMqtt(true);
                onClick();
              }}>
              Delete Device
            </MenuItem>
          )}
          content={({ onClose }) => (
            <Loaders loading={loading}>
              <CaptchaComponent
                onClose={onClose}
                onDelete={() => onDeleteDevice(_._id)}
                type="device"
                serial_number={_?.serial_number}
              />
            </Loaders>
          )}
        />
      )}
      {hasPermission('device.update-tag-string') && (
        <ModalContainer
          stateChanged={__ => setModelsState(___ => ({ ...___, ...__ }))}
          onModalClose={() => {
            setIgnoreMqtt(false);
          }}
          lg
          title="Update Tag String"
          btnComponent={({ onClick }) => (
            <MenuItem
              onClick={() => {
                setIgnoreMqtt(true);
                onClick();
              }}
              icon={<i className="material-icons-outlined">update</i>}>
              Update Tag String
            </MenuItem>
          )}
          content={({ onClose }) => <TagStringUpdate onClose={onClose} device={_} />}
        />
      )}
      {hasPermission('device.locate-device') && (
        <ModalContainer
          stateChanged={__ => setModelsState(___ => ({ ...___, ...__ }))}
          onModalClose={() => {
            setIgnoreMqtt(false);
          }}
          title="Device Location"
          btnComponent={({ onClick }) => (
            <MenuItem
              onClick={() => {
                setIgnoreMqtt(true);
                onClick();
              }}
              icon={<i className="material-icons-outlined">map</i>}>
              Locate Device
            </MenuItem>
          )}
          content={({ onClose }) => <DeviceLocationMap onClose={onClose} device={_} />}
        />
      )}
      {canViewOpenSearchLogs && (
        <ModalContainer
          stateChanged={__ => setModelsState(___ => ({ ...___, ...__ }))}
          onModalClose={() => {
            setIgnoreMqtt(false);
          }}
          width={1300}
          btnComponent={({ onClick }) => (
            <MenuItem
              onClick={() => {
                setIgnoreMqtt(true);
                onClick();
              }}
              icon={<i className="material-icons-outlined">receipt_long</i>}>
              View Device Logs
            </MenuItem>
          )}
          content={({ onClose }) => <DeviceOpenSearchLogs device={_} onClose={onClose} />}
        />
      )}
      {hasPermission('device.download-logs') && (
        <ModalContainer
          stateChanged={__ => setModelsState(___ => ({ ...___, ...__ }))}
          onModalClose={() => {
            setIgnoreMqtt(false);
          }}
          lg
          title="Download Device Logs"
          btnComponent={({ onClick }) => (
            <MenuItem
              onClick={() => {
                setIgnoreMqtt(true);
                onClick();
              }}
              icon={<i className="material-icons-outlined">download</i>}>
              Download Logs
            </MenuItem>
          )}
          content={({ onClose }) => <DownloadDeviceLogs onClose={onClose} device={_} autoSubmit />}
        />
      )}
    </MenuButton>
  );
}

export default DevicesActions;
